/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener("DOMContentLoaded", function () {
  const gridViewButton = document.querySelector(".toggle-grid-view");
  const listViewButton = document.querySelector(".toggle-list-view");
  const issuesList = document.querySelector(".latest-issues__list");

  gridViewButton.addEventListener("click", function () {
    issuesList.classList.add("grid-view");
    issuesList.classList.remove("list-view");
    gridViewButton.classList.add("active");
    listViewButton.classList.remove("active");
  });

  listViewButton.addEventListener("click", function () {
    issuesList.classList.add("list-view");
    issuesList.classList.remove("grid-view");
    listViewButton.classList.add("active");
    gridViewButton.classList.remove("active");
  });

  window.addEventListener("resize", function () {
    if (window.innerWidth < 769) {
      if (!gridViewButton.classList.contains("active")) {
        gridViewButton.classList.add("active");
      }
      if (listViewButton.classList.contains("active")) {
        listViewButton.classList.remove("active");
      }
      if (!issuesList.classList.contains("grid-view")) {
        issuesList.classList.add("grid-view");
      }
      if (issuesList.classList.contains("list-view")) {
        issuesList.classList.remove("list-view");
      }
    }
  });

  const sortSelect = document.querySelector("#sort-issues");

  sortSelect.addEventListener("change", function () {
 
    const url = new URL(window.location.href);
    const sortValue = sortSelect.value;
    url.searchParams.set("sort", sortValue);
    window.location.href = url.toString();
  });

  const sharePopup = document.getElementById("share-popup");
  const sharePopupContent = document.querySelector(".share-popup__content");

  document.querySelectorAll(".issue-interact__share-btn").forEach((button) => {
    button.addEventListener("click", function () {
      const issueCard = this.closest(".issue-card");
      const postUrl = issueCard.getAttribute("data-post-url");

      // Construct social share URLs
      const facebookUrl = `https://www.facebook.com/share.php?u=${encodeURIComponent(
        postUrl
      )}`;
      const twitterUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        postUrl
      )}`;
      const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
        postUrl
      )}`;

      // Update the popup with share buttons for this specific post (inline SVG icons)
      sharePopupContent.innerHTML = `
              <div class="social-rocket-buttons">
                  <div class="social-rocket-button social-rocket-facebook">
                      <a href="${facebookUrl}" target="_blank" rel="noopener noreferrer" aria-label="Share on Facebook">
                          <svg width="30" height="30" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                              <path d="M22 12.07C22 6.48 17.52 2 12 2S2 6.48 2 12.07C2 17.1 5.66 21.22 10.44 22v-7.02H7.9v-2.91h2.54V9.84c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.45h-1.25c-1.23 0-1.61.77-1.61 1.56v1.87h2.74l-.44 2.91h-2.3V22C18.34 21.22 22 17.1 22 12.07z"/>
                          </svg>
                      </a>
                  </div>
                  <div class="social-rocket-button social-rocket-twitter">
                      <a href="${twitterUrl}" target="_blank" rel="noopener noreferrer" aria-label="Tweet">
                          <svg width="30" height="30" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                              <path d="M22.46 6c-.77.35-1.6.59-2.46.69a4.27 4.27 0 0 0 1.88-2.36 8.46 8.46 0 0 1-2.7 1.03 4.23 4.23 0 0 0-7.32 3.86A12 12 0 0 1 3.16 4.9a4.22 4.22 0 0 0 1.31 5.64c-.65-.02-1.27-.2-1.81-.5v.05a4.23 4.23 0 0 0 3.39 4.15c-.31.08-.64.12-.98.12-.24 0-.48-.02-.71-.07a4.24 4.24 0 0 0 3.95 2.94A8.49 8.49 0 0 1 2 19.54a12 12 0 0 0 6.29 1.84c7.55 0 11.68-6.26 11.68-11.68 0-.18-.01-.35-.02-.53A8.35 8.35 0 0 0 22.46 6z"/>
                          </svg>
                      </a>
                  </div>
                  <div class="social-rocket-button social-rocket-linkedin">
                      <a href="${linkedinUrl}" target="_blank" rel="noopener noreferrer" aria-label="Share on LinkedIn">
                          <svg width="30" height="30" viewBox="0 0 24 24" fill="black" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
                              <path d="M19 3A2 2 0 0 1 21 5V19A2 2 0 0 1 19 21H5A2 2 0 0 1 3 19V5A2 2 0 0 1 5 3H19M8.34 17.34V10.67H5.67V17.34M7 9.5A1.33 1.33 0 1 0 7 6.84A1.33 1.33 0 0 0 7 9.5M18.33 17.34V13.84C18.33 12.07 17.46 11.17 16.09 11.17C15 11.17 14.37 11.78 14.11 12.31H14.07V10.67H11.5V17.34H14.18V14.19C14.18 13.6 14.28 13.03 14.96 13.03C15.63 13.03 15.64 13.65 15.64 14.23V17.34H18.33Z"/>
                          </svg>
                      </a>
                  </div>
              </div>
          `;

      // Position the popup below the clicked button
      const rect = this.getBoundingClientRect();
      sharePopup.style.left = `${rect.left + window.pageXOffset}px`;
      sharePopup.style.top = `${rect.bottom + window.pageYOffset}px`;

      // Show the popup
      sharePopup.style.display = "block";
    });
  });

  // Close popup when clicking outside
  document.addEventListener("click", function (event) {
    if (
      !sharePopup.contains(event.target) &&
      !event.target.closest(".post-interact__share-btn")
    ) {
      sharePopup.style.display = "none";
    }
  });
});
